import { render, staticRenderFns } from "./adv-master.vue?vue&type=template&id=2b0a6567&scoped=true&lang=pug&"
import script from "./adv-master.vue?vue&type=script&lang=js&"
export * from "./adv-master.vue?vue&type=script&lang=js&"
import style0 from "./adv-master.vue?vue&type=style&index=0&id=2b0a6567&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a6567",
  null
  
)

export default component.exports